/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const modalTokens = {
  ContainerBackgroundColorBaseDefault: '#ffffff',
  ContainerSpacingTopBaseDefaultMobile: '16px',
  ContainerSpacingTopBaseDefaultDesktop: '24px',
  ContainerSpacingRightBaseDefaultMobile: '20px',
  ContainerSpacingRightBaseDefaultDesktop: '32px',
  ContainerSpacingBottomBaseDefaultMobile: '20px',
  ContainerSpacingBottomBaseDefaultDesktop: '32px',
  ContainerSpacingLeftBaseDefaultMobile: '20px',
  ContainerSpacingLeftBaseDefaultDesktop: '32px',
  ContainerBorderColorBaseDefault: '#ebecec',
  ContainerBorderRadiusBaseDefault: '16px',
  ContainerBorderRadiusMobileDefault: '0px',
  HeaderContainerSpacingGapBaseDefault: '12px',
  HeaderContainerSpacingBottomBaseDefault: '20px',
  HeaderTitleFontFamilyBaseDefault: '"SangBleu Versailles", "fallback for SangBleu", serif',
  HeaderTitleFontSizeBaseDefault: '24px',
  HeaderTitleFontWeightBaseDefault: '600',
  HeaderTitleFontLeadingBaseDefault: '36px',
  HeaderActionSpacingMarginTopBaseDefault: '-12px',
  HeaderActionSpacingMarginRightBaseDefault: '-16px',
  FooterContainerSpacingTopBaseDefault: '32px',
} as const;
